import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import TopBar from './common/TopBar'
import SideBar from './common/SideBar'
import BottomBar from './common/BottomBar'
import Dashboard from './pages/Dashboard'
import Customer from './pages/Customer'
import CustomerDetails from './pages/CustomerDetails'
import Samples from './pages/Samples'
import NewSample from './pages/NewSample'
import OrderPublished from './pages/OrderPublished'
import Payment from './pages/Payment'
import Debtor from './pages/Debtor'
import OldPayment from './pages/OldPayment'
import Author from './pages/Author'
import BookPublishe from './pages/BookPublishe'
import BookDetail from './pages/BookDetail'
import Stock from './pages/Stock'
import Users from './pages/Users'
import Permissions from './pages/Permissions'
import PrintRequest from './pages/PrintRequest'
import Stores from './pages/Stores'
import Royalty from './pages/Royalty'
import RoyaltyPayment from './pages/RoyaltyPayment'
import OrderExercise from './pages/OrderExercise'
import OderDetail from './pages/OderDetail'
import ExerciseOrderDetail from './pages/ExerciseOrderDetail'
import NewOrder from './pages/NewOrder'
import NewExerciseOrder from './pages/NewExerciseOrder'
import Invoice from './pages/Invoice'
import DeliveryNote from './pages/DeliveryNote'
import PublishingReport from './pages/PublishingReport'
import AccountingReport from './pages/AccountingReport'
import StoresReport from './pages/StoresReport'
import ManagerInsights from './pages/ManagerInsights'
import AuditLog from './pages/AuditLog'
import Login from './pages/login'
import PasswordReset from './pages/PasswordReset'
import AccessDenied from './pages/AccessDenied'
import { PermissionRoute } from './common/PermissionGate'
import { ROUTE_PERMISSIONS } from './context/permissions'
import { useAuth } from './context/AuthContext'
import './App.css'

function ProtectedLayout() {
  const { user, requiresPasswordReset } = useAuth()
  const location = useLocation()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const mainColumnRef = useRef(null)

  useEffect(() => {
    setIsMobileMenuOpen(false)
  }, [location.pathname])

  useLayoutEffect(() => {
    if (!mainColumnRef.current) return
    mainColumnRef.current.scrollTop = 0
    mainColumnRef.current.scrollLeft = 0
  }, [location.pathname, location.search])

  if (!user) return <Navigate to='/login' state={{ from: location }} replace />
  if (requiresPasswordReset) {
    return <Navigate to='/reset-password' replace />
  }

  const userName =
    user.user_fullname ||
    user.fullname ||
    user.fullName ||
    user.name ||
    user.email
  const userRole = user.user_role || user.user_role || user.userRole || 'User'

  return (
    <div className='app-shell'>
      <TopBar
        companyName='Buck Press Publishing'
        userName={userName}
        userRole={userRole}
        isMenuOpen={isMobileMenuOpen}
        onMenuToggle={() => setIsMobileMenuOpen((open) => !open)}
      />
      <div className='app-body'>
        <SideBar
          isMobileOpen={isMobileMenuOpen}
          onNavigate={() => setIsMobileMenuOpen(false)}
        />
        <div className='app-main-column' ref={mainColumnRef}>
          <main className='app-content'>
            <Routes>
              <Route path='/dashboard' element={<Dashboard />} />
              <Route path='/access-denied' element={<AccessDenied />} />
              <Route
                path='/customers'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.customers}>
                    <Customer />
                  </PermissionRoute>
                }
              />
              <Route
                path='/samples'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.samples}>
                    <Samples />
                  </PermissionRoute>
                }
              />
              <Route
                path='/samples/new'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.sampleCreate}>
                    <NewSample />
                  </PermissionRoute>
                }
              />
              <Route
                path='/sales/orders'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.orders}>
                    <OrderPublished />
                  </PermissionRoute>
                }
              />
              <Route
                path='/sales/payments'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.payments}>
                    <Payment />
                  </PermissionRoute>
                }
              />
              <Route
                path='/sales/debtors'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.debtors}>
                    <Debtor />
                  </PermissionRoute>
                }
              />
              <Route
                path='/sales/old-payments'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.oldPayments}>
                    <OldPayment />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/authors'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.authors}>
                    <Author />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/stock'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.stock}>
                    <Stock />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/users'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.users}>
                    <Users />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/stores'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.stores}>
                    <Stores />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/royalties'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.royalties}>
                    <Royalty />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/royalties/payments'
                element={
                  <PermissionRoute
                    permissions={ROUTE_PERMISSIONS.royaltyPayments}
                  >
                    <RoyaltyPayment />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/print-request'
                element={
                  <PermissionRoute
                    permissions={ROUTE_PERMISSIONS.printRequests}
                  >
                    <PrintRequest />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/reports/publishing'
                element={
                  <PermissionRoute
                    permissions={ROUTE_PERMISSIONS.publishingReports}
                  >
                    <PublishingReport />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/reports/accounting'
                element={
                  <PermissionRoute
                    permissions={ROUTE_PERMISSIONS.accountingReports}
                  >
                    <AccountingReport />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/reports/stores'
                element={
                  <PermissionRoute
                    permissions={ROUTE_PERMISSIONS.storesReports}
                  >
                    <StoresReport />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/reports/insights'
                element={
                  <PermissionRoute
                    permissions={ROUTE_PERMISSIONS.managerInsights}
                  >
                    <ManagerInsights />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/audit-log'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.auditLog}>
                    <AuditLog />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/users/permissions'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.permissions}>
                    <Permissions />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/books/publish-books'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.books}>
                    <BookPublishe key='published-books' />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/books/publish-books/:bookId'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.bookView}>
                    <BookDetail />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/books/exercise-books'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.books}>
                    <BookPublishe
                      key='exercise-books'
                      bookType='exercise_book'
                      heading='Exercise books'
                      breadcrumb='Exercise Books'
                      listTitle='Exercise book list'
                      basePath='/admin/books/exercise-books'
                      showAuthors={false}
                      showRank={false}
                      showIsbn={false}
                    />
                  </PermissionRoute>
                }
              />
              <Route
                path='/admin/books/exercise-books/:bookId'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.bookView}>
                    <BookDetail
                      basePath='/admin/books/exercise-books'
                      breadcrumb='Exercise Books'
                      showAuthors={false}
                    />
                  </PermissionRoute>
                }
              />
              <Route
                path='/sales/orders/new'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.orderCreate}>
                    <NewOrder />
                  </PermissionRoute>
                }
              />
              <Route
                path='/sales/orders/:orderId'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.orderView}>
                    <OderDetail />
                  </PermissionRoute>
                }
              />
              <Route
                path='/sales/orders/:orderId/edit'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.orderEdit}>
                    <NewOrder />
                  </PermissionRoute>
                }
              />
              <Route
                path='/sales/orders/publish-books'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.orders}>
                    <OrderPublished />
                  </PermissionRoute>
                }
              />
              <Route
                path='/sales/orders/exercise-books'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.orders}>
                    <OrderExercise />
                  </PermissionRoute>
                }
              />
              <Route
                path='/sales/orders/exercise-books/new'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.orderCreate}>
                    <NewExerciseOrder />
                  </PermissionRoute>
                }
              />
              <Route
                path='/sales/orders/exercise-books/:orderId'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.orderView}>
                    <ExerciseOrderDetail />
                  </PermissionRoute>
                }
              />
              <Route
                path='/sales/orders/exercise-books/:orderId/edit'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.orderEdit}>
                    <NewExerciseOrder />
                  </PermissionRoute>
                }
              />
              <Route
                path='/sales/orders/exercise-books/:orderId/edit'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.orderEdit}>
                    <OrderExercise />
                  </PermissionRoute>
                }
              />
              <Route
                path='/customers/:customerId'
                element={
                  <PermissionRoute permissions={ROUTE_PERMISSIONS.customers}>
                    <CustomerDetails />
                  </PermissionRoute>
                }
              />
              <Route path='*' element={<Navigate to='/dashboard' replace />} />
            </Routes>
          </main>
          <BottomBar />
        </div>
      </div>
    </div>
  )
}

function App() {
  return (
    <Routes>
      <Route path='/login' element={<Login />} />
      <Route path='/reset-password' element={<PasswordReset />} />
      <Route
        path='/invoice/:invoiceId'
        element={
          <PermissionRoute permissions={ROUTE_PERMISSIONS.orderView}>
            <Invoice />
          </PermissionRoute>
        }
      />
      <Route
        path='/order/deliverynote/:orderId'
        element={
          <PermissionRoute permissions={ROUTE_PERMISSIONS.orderView}>
            <DeliveryNote />
          </PermissionRoute>
        }
      />
      <Route path='*' element={<ProtectedLayout />} />
    </Routes>
  )
}

export default App
